import { r as a, c as s, h as i, H as n, g as d } from "./main-bb89b2f2.js";
import "vue";
const c = '*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.relative{position:relative}.flex{display:flex}.grid{display:grid}:host{display:flex;position:relative}.hide-scrollbar{-ms-overflow-style:none;scrollbar-width:none}.hide-scrollbar::-webkit-scrollbar{display:none}.touch-scrollbar{-webkit-overflow-scrolling:"touch";scroll-behavior:"smooth"}#gallery-carousel-container{padding:1%}#grid>*{min-width:0}.sr-only{clip:rect(0,0,0,0);border-width:0;height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}.visible{visibility:visible}.invisible{visibility:hidden}.static{position:static}.z-10{z-index:10}.z-0{z-index:0}.mx-auto{margin-right:auto}.ml-auto,.mx-auto{margin-left:auto}.mr-auto{margin-right:auto}.box-border{box-sizing:border-box}.hidden{display:none}.w-full{width:100%}.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.resize{resize:both}.grid-flow-col{grid-auto-flow:column}.overflow-visible{overflow:visible}.overflow-y-visible{overflow-y:visible}.overflow-x-scroll{overflow-x:scroll}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.transition{transition-duration:.15s;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1)}.block{display:block}', h = c, b = class {
  constructor(e) {
    a(this, e), this.lhGalleryCarouselItemSelected = s(this, "lhGalleryCarouselItemSelected", 7), this.nextClicked = async () => {
      await this.next();
    }, this.prevClicked = async () => {
      await this.prev();
    }, this.activeElementStyle = "transform: scaleX(1.0) scaleY(1.0); transition: 0.25s ease-in-out; box-shadow: var(--shadow-elevation-basic);", this.gap = "32px", this.iconSize = "48px", this.inactiveElementStyle = "transform: scaleX(0.8) scaleY(0.8); transition: 0.25s ease-in-out;", this.value = void 0, this.width = "auto";
  }
  /**
   * Reacts to a change of the value
   * @param newValue The new value of this component
   */
  valueWatcher(e) {
    this.handleValueChange(e);
  }
  /**
   * Selects the next or previous item if an arrow key was pressed
   * @param event
   */
  async onKeyDownEvent(e) {
    e.key === "ArrowLeft" && await this.prev(), e.key === "ArrowRight" && await this.next();
  }
  /**
   * Called every time the component is connected to the DOM:
   */
  connectedCallback() {
    this.hostElement.addEventListener("keydown", this.onKeyDownEvent);
  }
  /**
   * Called every time the component is disconnected to the DOM:
   */
  disconnectedCallback() {
    this.hostElement.removeEventListener("keydown", this.onKeyDownEvent);
  }
  handleResize() {
    this.hideIconsIfNeeded();
  }
  hideIconsIfNeeded() {
    const e = this.galleryCarouselContainerElement;
    e !== void 0 && (this.hostElement.offsetWidth < e.scrollWidth ? (this.prevButton.classList.remove("hidden"), this.nextButton.classList.remove("hidden")) : (this.prevButton.classList.add("hidden"), this.nextButton.classList.add("hidden")));
  }
  /**
   * Handle a value change. This is called, when the value changes programatically (not by the user selecting the value).
   */
  handleValueChange(e) {
    var t;
    if (e !== null) {
      const r = this.querySelectionGalleryItems();
      this.deselectAllOther(r, e);
      const l = r.find((o) => o.value == e);
      l != null && (l.selected = !0, this.selectedElement = l, (t = this.galleryCarouselContainerElement) === null || t === void 0 || t.scrollTo({
        left: l.offsetLeft - l.clientWidth * 1.5,
        behavior: "smooth"
      }));
    }
  }
  onInternalItemSelection(e) {
    var t;
    e.stopPropagation(), this.value = e.detail.value, this.handleValueChange(e.detail.value), this.lhGalleryCarouselItemSelected.emit({ value: (t = e.detail.value) === null || t === void 0 ? void 0 : t.toString() });
  }
  /**
   * Selects the next Item, if one is available
   */
  async next() {
    const e = this.querySelectionGalleryItems(), t = e.indexOf(this.selectedElement);
    t < e.length - 1 && (e[t + 1].selected = !0);
  }
  /**
   * Selects the previous Item, if one is available
   */
  async prev() {
    const e = this.querySelectionGalleryItems(), t = e.indexOf(this.selectedElement);
    t > 0 && (e[t - 1].selected = !0);
  }
  /**
   *
   * @returns Array of all Gallery-Carousel-Item Elements
   */
  querySelectionGalleryItems() {
    const e = this.hostElement.querySelectorAll("patternlib-gallery-carousel-item");
    return e.length == 0 && console.warn("<patternlib-gallery-carousel> needs one or more <patternlib-gallery-carousel-item> as children"), Array.from(e);
  }
  /**
   * Deselects every element except the one matching the value parameter
   * @param galleryItems all child gallery-carousel-items
   * @param value the value of the element to NOT deselect
   */
  deselectAllOther(e, t) {
    e.filter((l) => l.value != t).map((l) => {
      l.selected = !1;
    });
  }
  componentWillLoad() {
    this.handleValueChange(this.value);
  }
  componentDidRender() {
    this.hideIconsIfNeeded();
  }
  render() {
    const e = {
      invisible: this.querySelectionGalleryItems().indexOf(this.selectedElement) == 0,
      "z-10": !0,
      "ml-auto": !0
    }, t = {
      invisible: this.querySelectionGalleryItems().indexOf(this.selectedElement) == this.querySelectionGalleryItems().length - 1,
      "z-10": !0,
      "mr-auto": !0
    };
    return i(n, { key: "73baff4f81fdd28bfddd3780be4102fb2c6233d3", class: "overflow-visible", tabindex: "0", style: { width: this.width, overflow: "visible" } }, i("div", { key: "07df986763823eabfbb643e32064d2b9ee56cb89", class: "w-full overflow-visible", tabindex: "0" }, i("div", { key: "29c717d7230f4301a043046d457beacb164e7616", class: "flex box-border overflow-visible", style: { gridAutoFlow: "column", gap: "16px" }, tabindex: "0" }, i("button", { key: "3cb502d7ff00ffded15d68704b725f7d56d5c097", type: "button", id: "button-prev", ref: (r) => this.prevButton = r, class: e, onClick: this.prevClicked, tabindex: "0" }, i("span", { key: "2eae46b222ed9595fc82813ad773b4e8d082badc", class: "" }, i("patternlib-icon", { key: "8e11aaf0d3b1032bac1264d254d1ed7515830546", iconName: "arrow-left", size: this.iconSize, bold: !0 }), i("span", { key: "24e96d27c1368ec0dbe654c147f6beade9f2042d", class: "sr-only" }, "Previous"))), i("div", { key: "b118bb364d16cf494f7e467a55a23c9619c386b0", id: "gallery-carousel-container", ref: (r) => this.galleryCarouselContainerElement = r, class: "grid box-border grid-flow-col mx-auto overflow-x-scroll overflow-y-visible touch-scrollbar hide-scrollbar z-0", style: { gap: this.gap }, tabindex: "0" }, i("slot", { key: "d46a6e866b5290b7fa6f413c785ddb949e5223a5" })), i("button", { key: "e93239a12e55eb05807bb176779b672bcca9e13c", type: "button", id: "button-next", ref: (r) => this.nextButton = r, class: t, onClick: this.nextClicked, tabindex: "0" }, i("span", { key: "6799be610f16cdf5144f11e9f561d1809163c3b8", class: "" }, i("patternlib-icon", { key: "e3cd5a2980b05a3a1a9e0069a2ff63b252ce21f9", iconName: "arrow-right", size: this.iconSize, bold: !0 }), i("span", { key: "bb534dfbd82eb973ad8d8adbdf3ad9627fd54e60", class: "sr-only" }, "Next"))))));
  }
  get hostElement() {
    return d(this);
  }
  static get watchers() {
    return {
      value: ["valueWatcher"]
    };
  }
};
b.style = h;
export {
  b as patternlib_gallery_carousel
};
